$(document).on('click', 'div[popoverButton]', function () {
    var id = $(this).attr('popoverButton');
    if ($('.popup--content[popoverContent="' + id + '"]').is(':visible')) {
        $('.popup--content[popoverContent="' + id + '"]').fadeOut();
        $(this).removeClass('active');
    } else {
        $('.popup--content[popoverContent="' + id + '"]').fadeIn();
        $('.popup--content:not([popoverContent="' + id + '"])').fadeOut();
        $(this).addClass('active');
    }

    $(document).mouseup(function (e) {
        var container = $('.popup--content');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.popup--content').fadeOut();
            $('div[popoverButton]').removeClass('active');
        }
    });
});

//form front
$(document).on('mouseenter', 'div[popoverButtonHover]', function() {
    // Innerhalb der aktuellen Popover-Wrapper (das übergeordnete Element)
    var $wrap = $(this).closest('.popover--wrap--hover');
    var $popover = $wrap.find('div[popoverContent]');
    
    // Zeige den Popover und positioniere ihn relativ zum Button
    $popover.show().removeClass('hidden').css({
      top: $wrap.offset().top + $wrap.outerHeight(),
      left: $wrap.offset().left
    });
  });
  
  $(document).on('mouseleave', 'div[popoverButtonHover]', function() {
    var $wrap = $(this).closest('.popover--wrap--hover');
    var $popover = $wrap.find('div[popoverContent]');
    
    // Kurz verzögert prüfen, ob die Maus den Popover berührt
    setTimeout(function() {
      if (!$popover.is(':hover')) {
        $popover.hide().addClass('hidden');
      }
    }, 100);
  });
  
  $(document).on('mouseenter', 'div[popoverContent]', function() {
    $(this).show().removeClass('hidden');
  });
  
  $(document).on('mouseleave', 'div[popoverContent]', function() {
    $(this).hide().addClass('hidden');
  });
  

  //team
$(document).on('mouseenter', 'div[popoverButtonTeam]', function() {
    // Innerhalb der aktuellen Popover-Wrapper (das übergeordnete Element)
    var $wrap = $(this).closest('.popover--wrap--team');
    var $popover = $wrap.find('div[popoverContent]');
    
    // Zeige den Popover und positioniere ihn relativ zum Button
    $popover.show().removeClass('hidden').css({
      top: $wrap.offset().top + $wrap.outerHeight(),
      left: $wrap.offset().left
    });
  });
  
  $(document).on('mouseleave', 'div[popoverButtonTeam]', function() {
    var $wrap = $(this).closest('.popover--wrap--team');
    var $popover = $wrap.find('div[popoverContent]');
    
    // Kurz verzögert prüfen, ob die Maus den Popover berührt
    setTimeout(function() {
      if (!$popover.is(':hover')) {
        $popover.hide().addClass('hidden');
      }
    }, 100);
  });
  
  $(document).on('mouseenter', 'div[popoverContent]', function() {
    $(this).show().removeClass('hidden');
  });
  
  $(document).on('mouseleave', 'div[popoverContent]', function() {
    $(this).hide().addClass('hidden');
  });
  
  


// $('div[choicenegation]').on('click', function () {

//     var negation = $(this).attr('choiceNegation');
//     var option_cookie = $(this).attr('cookieKey');

//     localStorage.setItem("selectedOption", option_cookie);


//     $(this).siblings().removeClass('hidden');
//     $(this).addClass('hidden');
//     $('#choiceNegation').html(negation);

//     $('.popup--content').fadeOut();
//     $('div[popoverButton]').removeClass('active');
//   });




// copy current url to clipboard (blog single)
function copyLink() {
    var copyText = window.location.href;
    navigator.clipboard.writeText(copyText);
}
$('.copy--link').click(function (e) {
    e.preventDefault();
    copyLink();
    return false;
});
